import {Component} from "react";
import appLib from "../../../libs/appLib.mjs";
import {Button, ButtonGroup} from "reactstrap";
import TextLabel from "../../../controls/TextLabel.mjs";
import Glob from "../../../libs/Glob.mjs";
import TrashIcon from "../../../media/assets/TrashIcon.mjs";
import CloseIcon from "../../../media/assets/CloseIcon.mjs";

const prefix = "UserIndex";

const UserDeletion = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user: appLib.currentUser(),
			lang: Glob.getLanguage()
		};
		this.doDelete = this.doDelete.bind(this);
	}
	doDelete() {
		this.setState({ sending: true}, () => {
			appLib.api('auth/delete-me').then( res => {
				if ( res?.deleted ) {
					Glob.trigger('my_user_deletion', false);
					appLib.logout();
				}
			}).catch( err => {
				console.log(err);
			}).finally( () => {
				this.setState({ sending: false });
			})
		});
	}
	render() {
		return (
			<div className={prefix+"-user-deletion"}>
				<strong className={"title"}>
					<TrashIcon fill={"#c00"}/>
					<span>{ this.state.user.email }</span>
				</strong>
				<div>
					{ this.state.lang === 'it' ? (
						<div>
							<p>
								Stai per procedere alla <strong style={{color:"#c00",textDecoration:"underline"}}>cancellazione</strong> del tuo utente,
								non solo al Logout: <strong>tutti i tuoi contributi (post) spariranno dalla Bacheca</strong>.
							</p>
							<p>
								Per riattivare il tuo utente sarà sufficiente fare di nuovo login con questa stessa email.
							</p>
						</div>
					) : (
						<div>
							<p>
								You are about to <strong style={{color:"#c00",textDecoration:"underline"}}>delete</strong> your user account, not just
								Logout: <strong>All your contributions (posted ads) will disappear from the Noticeboard</strong>.
							</p>
							<p>
								To reactivate your account, simply Login again with this same email address.
							</p>
						</div>
					)}
					<ButtonGroup
						className={"btn-icon"}
					>
						<Button
							color={"success"}
							type={"button"}
							onClick={ () => Glob.trigger('my_user_deletion', false)}
						>
							<i>
								<CloseIcon />
							</i>
							<b>
								<TextLabel value={"Cancel"} />
							</b>
						</Button>
						<Button
							type={"button"}
							color={"danger"}
							disabled={ !! this.state.sending }
							onClick={ this.doDelete }
						>
							<b>
								<TextLabel value={"Delete"} />
							</b>
							<i>
								<TrashIcon />
							</i>
						</Button>
					</ButtonGroup>
				</div>
			</div>
		)
	}
}

export default UserDeletion;